import React from 'react'
import { BsrsGrid, Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import NameColumn from '@/components/BsrsGrid/BsrsGrid.NameColumn'
import { localized } from '@/decorators/localized'
import { WhiteBox } from '@/components/Layout'
import { removeCommandCell } from './commandCells'
import { getDatasetName } from '@/utils/outputReports'

@localized()
class DatasetGrid extends React.Component {
  render () {
    const { localize, locale, onReportSubmissionGroupRemove } = this.props
    const { index, reportSubmissionGroups } = this.props.dataset
    return (
      <WhiteBox dataCy='DatasetBox' header={`${localize('Reporting.Dataset')} ${getDatasetName(index, localize)}`}>
        <BsrsGrid
          simpleView
          items={reportSubmissionGroups}>
          {NameColumn({ nameProp: 'institutionName', latinNameProp: 'institutionLatinName', locale, title: localize('Reporting.InstitutionName'), editable: false })}
          {NameColumn({ nameProp: 'reportGroupName', latinNameProp: 'reportGroupLatinName', locale, title: localize('Reporting.ReportingGroup'), editable: false })}
          <Column field='name' title={localize('Common.Name')} editable={false} />
          <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
          <Column field='snapshotDate' title={localize('Reporting.SnapshotDate')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
          <Column cell={removeCommandCell({ localize, datasetIndex: index, onReportSubmissionGroupRemove })} width='150px' filterable={false} editable={false} />
        </BsrsGrid>
      </WhiteBox>
    )
  }
}

export {
  DatasetGrid
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/grids/datasetGrid.js